<script>
    import MIcon from "../components/MIcon.svelte";
</script>

<MIcon class="heart">favorite</MIcon>